import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { List } from 'palette/List';
import SortingListItem from './SortingListItem';

function SortingList({
    theme,
    closeSlidePanel
}) {
    const sortBy = useSelector(state => state.sortBy);

    return (
        <List className={classNames('filters__list filters__list--sorting', {
            [`filters__list--${theme}`]: theme
        })}
        >
            {sortBy.map(item => (
                <SortingListItem
                    key={item.value}
                    closeSlidePanel={closeSlidePanel}
                    {...item}
                />
            ))}
        </List>
    );
}

export default SortingList;
